/**
 * Bezier curve utilities for entity linking connections
 */

import type { Point } from '../types/linking-view.types';

/**
 * Calculate bezier path string for a horizontal S-curve
 *
 * @param start - Starting point coordinates
 * @param end - Ending point coordinates
 * @returns SVG path string for a cubic bezier curve
 */
export function calculateBezierPath(start: Point, end: Point): string {
  const dx = end.x - start.x;
  const curvature = 0.4;
  const cp1x = start.x + dx * curvature;
  const cp2x = end.x - dx * curvature;

  return `M ${start.x} ${start.y} C ${cp1x} ${start.y}, ${cp2x} ${end.y}, ${end.x} ${end.y}`;
}
